import { useLazyQuery } from "@apollo/client";
import { useMemo, useCallback } from "react";
import { IOnlinePharmacyConfigResponse } from "./online-pharmacy-config.interface";
import { GET_ONLINE_PHARMACY_CONFIG } from "./online-pharmacy-config.query";
import { mapOnlinePharmacyConfig } from "./online-pharmacy-config.mapper";

export const useOnlinePharmacyConfig = () => {
  const [getOnlinePharmacyConfig, { data, loading, error }] = useLazyQuery<IOnlinePharmacyConfigResponse>(
    GET_ONLINE_PHARMACY_CONFIG,
    {
      fetchPolicy: "network-only",
      nextFetchPolicy: "network-only",
    },
  );

  const configData = useMemo(() => {
    return mapOnlinePharmacyConfig(data?.onlinePharmacyConfig);
  }, [data]);

  const executeGetConfig = useCallback(() => {
    getOnlinePharmacyConfig();
  }, [getOnlinePharmacyConfig]);

  return {
    executeGetConfig,
    data: configData,
    loading,
    error,
  };
};
